import React, { useEffect } from 'react'
import styled from 'styled-components'
import Flex from 'components/Flex'
import { useNavigate, useSearchParams } from 'react-router-dom'

export const Wrapper = styled(Flex)`
  height: 100vh;
  width: 100%;
  background-color: #f6f6f6;
`

const SignInCard = styled.div`
  background-color: white;
  padding: 40px 32px;
  border-radius: 3px;
  max-width: 450px;
  width: 100%;
  margin: auto;
  box-shadow: 0px 2px 10px rgba(99, 116, 135, 0.2);
`
const { AUTH_URL } = process.env

const UserSignin = ({ token, SignIn, corporateId }) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const handleSignIn = data => {
    SignIn(data)
  }

  useEffect(() => {
    const urlToken = searchParams.get('token')
    handleSignIn(urlToken)
    if (!urlToken && !token) {
      window.open(AUTH_URL, '_self')
    }
  }, [])

  useEffect(() => {
    if (token) {
      navigate('/dashboard')
    }
  }, [token])

  return (
    <Wrapper column>
      <SignInCard>Loading...</SignInCard>
    </Wrapper>
  )
}
export default UserSignin
